import { render, staticRenderFns } from "./rfq-view.vue?vue&type=template&id=53bf3602&scoped=true"
import script from "./rfq-view.vue?vue&type=script&lang=js"
export * from "./rfq-view.vue?vue&type=script&lang=js"
import style0 from "./rfq-view.vue?vue&type=style&index=0&id=53bf3602&prod&lang=css"
import style1 from "./rfq-view.vue?vue&type=style&index=1&id=53bf3602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf3602",
  null
  
)

export default component.exports